import { useEffect } from 'react';
import { RouterProvider } from 'react-router';
import { router } from './router/index.js';
import { AuthContext, useAuthState } from './features/auth/useAuth.js';
import { SplashScreen } from './components/SplashScreen.js';
import { UpdatePrompt, SHOW_RELEASE_NOTES_KEY } from './components/UpdatePrompt.js';

function AuthProvider({ children }: { children: React.ReactNode }) {
  const authValue = useAuthState();

  // ランディングページはスプラッシュ不要（認証・位置情報を使わないため）
  const isLanding = window.location.pathname === '/landing';
  const splashVisible = !isLanding && authValue.loading;

  return (
    <AuthContext.Provider value={authValue}>
      <SplashScreen visible={splashVisible} />
      {children}
    </AuthContext.Provider>
  );
}

export default function App() {
  // 更新後リロードでリリースノートページへ自動遷移
  useEffect(() => {
    if (localStorage.getItem(SHOW_RELEASE_NOTES_KEY)) {
      localStorage.removeItem(SHOW_RELEASE_NOTES_KEY);
      router.navigate('/release-notes', { replace: true });
    }
  }, []);

  return (
    <AuthProvider>
      <RouterProvider router={router} />
      <UpdatePrompt />
    </AuthProvider>
  );
}
